import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { CssTextField } from "../../components/TextInputField/TextInputField";
import { addReportInput, reportValue } from "./module/actions";
import { selectReportValue } from "./module/selectors";
import classes from "./ReportStepTwo/ReportStepTwo.module.scss";

const ReporTextField = (props: any) => {
  const {
    setInputLabelValue,
    addReportInput,
    label,
    id,
    initialValue,
    value,
    parameter,
    property,
  } = props;

  const [inputValue, setInputValue] = useState<string>("");

  useEffect(() => {
    addReportInput(
      initialValue ? initialValue : "",
      id,
      parameter,
      label,
      property
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (value && value.length > 0) {
      let temp = value.filter((input: any) => input.id === id);
      setInputValue(temp.value);
    }
  }, [value, id]);

  return (
    <div>
      <span className={classes["input-wrapper-description"]}>{label}</span>

      <CssTextField
        variant="filled"
        fullWidth
        type={"text"}
        onChange={(val: any) => {
          setInputLabelValue(val.target.value, id);
        }}
        value={inputValue}
      />
    </div>
  );
};

const mapStateToProps: any = () =>
  createStructuredSelector({
    value: selectReportValue,
  });

const mapDispatchToProps: any = {
  setInputLabelValue: (value: any, id: any) => reportValue({ value, id }),
  addReportInput: (
    value: any,
    id: any,
    parameter: any,
    label: any,
    property: any
  ) => addReportInput({ value, id, parameter, label, property }),
};

const withConnect: any = connect(mapStateToProps, mapDispatchToProps);

export default withConnect(ReporTextField);
